module.exports = __webpack_public_path__ + "img/Chubb.9a04112f.jpg";